import {ThemeColorName} from '../..';
import {ThemeSpacingName} from '../../theme';
import {DatePickerKind, DatePickerSize} from './types';

export const DatePickerTriggerStyleMap: {
  [key in DatePickerKind]: {
    [key in DatePickerSize]: {
      textColor: ThemeColorName;
      backgroundColor: ThemeColorName;
      padding: ThemeSpacingName;
      height: number;
    };
  };
} = {
  Default: {
    Small: {
      textColor: 'content_mono_secondary',
      backgroundColor: 'background_mono_tertiary',
      padding: '8',
      height: 32,
    },
    Default: {
      textColor: 'content_mono_secondary',
      backgroundColor: 'background_mono_tertiary',
      padding: '14',
      height: 44,
    },
    Large: {
      textColor: 'content_mono_secondary',
      backgroundColor: 'background_mono_tertiary',
      padding: '18',
      height: 56,
    },
  },
  Success: {
    Small: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_positive_light',
      padding: '8',
      height: 32,
    },
    Default: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_positive_light',
      padding: '14',
      height: 44,
    },
    Large: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_positive_light',
      padding: '18',
      height: 56,
    },
  },
  Error: {
    Small: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_negative_light',
      padding: '8',
      height: 32,
    },
    Default: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_negative_light',
      padding: '14',
      height: 44,
    },
    Large: {
      textColor: 'content_mono_primary',
      backgroundColor: 'background_negative_light',
      padding: '18',
      height: 56,
    },
  },
  Disabled: {
    Small: {
      textColor: 'content_mono_disabled',
      backgroundColor: 'background_mono_tertiary',
      padding: '8',
      height: 32,
    },
    Default: {
      textColor: 'content_mono_disabled',
      backgroundColor: 'background_mono_tertiary',
      padding: '14',
      height: 44,
    },
    Large: {
      textColor: 'content_mono_disabled',
      backgroundColor: 'background_mono_tertiary',
      padding: '18',
      height: 56,
    },
  },
};
